import { Cancel, Search } from "@mui/icons-material"
import { InputAdornment, TextField, Tooltip } from "@mui/material"
import { QuickFilterClear, QuickFilterControl, QuickFilterTrigger, ToolbarButton, QuickFilter as ToolbarQuickFilter } from "@mui/x-data-grid-premium"

export default function QuickFilter() {
  return <ToolbarQuickFilter style={{ display: "grid", alignItems: "center" }}>
    <QuickFilterTrigger
      render={(triggerProps, state) => (
        <Tooltip title="Search">
          <ToolbarButton
            {...triggerProps}
            sx={(theme) => ({
              gridArea: "1 / 1",
              width: "min-content",
              height: "min-content",
              zIndex: 1,
              opacity: state.expanded ? 0 : 1,
              pointerEvents: state.expanded ? "none" : "auto",
              transition: theme.transitions.create(["opacity"]),
            })}
          >
            <Search fontSize="small" />
          </ToolbarButton>
        </Tooltip>
      )}
    />
    <QuickFilterControl
      render={({ ref, ...controlProps }, state) => <TextField
        {...controlProps}
        inputRef={ref}
        aria-label="Search"
        placeholder="Search..."
        size="small"
        sx={(theme) => ({
          gridArea: "1 / 1",
          overflowX: "clip",
          width: state.expanded ? 260 : "var(--trigger-width)",
          opacity: state.expanded ? 1 : 0,
          transition: theme.transitions.create(["width", "opacity"]),
        })}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: state.value ? (
              <InputAdornment position="end">
                <QuickFilterClear
                  edge="end"
                  size="small"
                  aria-label="Clear search"
                  material={{ sx: { marginRight: -0.75 } }}
                >
                  <Cancel fontSize="small" />
                </QuickFilterClear>
              </InputAdornment>
            ) : null,
            ...controlProps.slotProps?.input,
          },
          ...controlProps.slotProps,
        }}
      />}
    />
  </ToolbarQuickFilter>
}
